export function parseStoredVar(storedValue: string | null) {
  if (storedValue === null) {
    return undefined
  }

  // It is possible that malformed JSON is stored, e.g. "undefined", this
  // prevents a full page crash
  try {
    return JSON.parse(storedValue)
  } catch {
    return undefined
  }
}
